import ContractRequestTypeChart from './RequestsTypeChart';

export default ContractRequestTypeChart;
